// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"16b440c516de7ee793e7","532":"cf3238cc9cf61632be21","691":"25f3603f9ca050f52d8e"}[chunkId] + ".js";
};